import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Grid, Button } from 'react-bootstrap';
import MetaTags from 'react-meta-tags';
import classNames from 'classnames';

import { toggleNav } from '../../state/app-dux';

import NavLink from '../ui/NavItemLink';
import Footer from '../ui/Footer';

// production GTM-MD9GB6L, dev GTM-5VZ6PGX
const GTM_TRACKING_CODE = process.env.REACT_APP_GTM_CODE;

const addScriptTag = (id, body) => {
  const el = document.getElementById(id);
  if (el) return;
  const script = document.createElement('script');
  script.text = body;
  script.id = id;
  document.head.appendChild(script);
};

const addNoScriptTag = (id, body) => {
  const el = document.getElementById(id);
  if (el) return;
  const script = document.createElement('noscript');
  script.text = body;
  script.id = id;
  document.body.prepend ? document.body.prepend(script) : null;
};

const loginBtnStyle = {
  textTransform: 'uppercase',
  border: 'none',
  background: 'transparent',
  border: '1px solid',
  color: '#b21f20',
  borderRadius: '0',
  fontWeight: 'bold'
}

class Layout extends Component {
  componentDidMount() {
    const gtmCode = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${GTM_TRACKING_CODE}')`;
    addScriptTag('gtmCode', gtmCode);

    const noscript = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_TRACKING_CODE}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    addNoScriptTag('gtmNoScript', noscript);
  }
  render() {
    const {
      children,
      isNavOpen,
      onToggleNav,
      route,
      knowledgeCenter,
      isPreview,
      versionName
    } = this.props;
    const handleNavClick = e => {
      e.preventDefault();
      e.stopPropagation();
      onToggleNav(!isNavOpen);
    };
    return (
      <section className={`route-${route}`}>
        <MetaTags>
          <title>Winexray</title>
          <meta charSet="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
          <meta name="description" content="" />
          <meta name="keywords" content="" />
          <meta name="author" content="WINEXRAY LLC" />
          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href="/favicons/apple-touch-icon.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href="/favicons/favicon-32x32.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="16x16"
            href="/favicons/favicon-16x16.png"
          />
          <link rel="manifest" href="/favicons/site.webmanifest" />
          <link
            rel="mask-icon"
            href="/favicons/safari-pinned-tab.svg"
            color="#c82324"
          />
          <link rel="shortcut icon" href="/favicons/favicon.ico" />
          <meta name="apple-mobile-web-app-title" content="WineXRay" />
          <meta name="application-name" content="WineXRay" />
          <meta name="msapplication-TileColor" content="#c82324" />
          <meta
            name="msapplication-config"
            content="/favicons/browserconfig.xml"
          />
          <meta name="theme-color" content="#ffffff" />
          <meta property="og:image" content="/favicons/opengraph.jpg" />
        </MetaTags>

        <header className={knowledgeCenter ? 'knowledge-center' : ''}>
          {isPreview &&
            <div
              style={{
                backgroundColor: '#C82324',
                color: 'white',
                textAlign: 'center',
                fontWeight: 'bold',
                padding: '5px',
                position: 'fixed',
                width: '100%',
                opacity: '.7'
              }}
            >
              CMS PREVIEW - {versionName}
            </div>}
          <Grid>
            <Link to="/" className="brand" />
            <button
              className={classNames('hamburger hamburger--stand', {
                'is-active': isNavOpen
              })}
              type="button"
              onClick={handleNavClick}
            >
              <span className="hamburger-box">
                <span className="hamburger-inner" />
              </span>
            </button>
            <nav className={classNames({ 'is-open': isNavOpen })}>
              {!knowledgeCenter &&
                <ul>
                  <NavLink to="/knowledge-center" toggleNav={handleNavClick}>
                    Knowledge center
                  </NavLink>
                  <NavLink to="/client-login" toggleNav={handleNavClick}>
                    <Button bsStyle="primary" type="button" style={loginBtnStyle}>
                      Client login
                    </Button>
                  </NavLink>
                </ul>}
              {!knowledgeCenter &&
                <ul>
                  <NavLink to="/how-we-do-it" toggleNav={handleNavClick}>
                    What we do & what we measure
                  </NavLink>
                  <NavLink to="/what-we-do" toggleNav={handleNavClick}>
                    Who are our clients & applications
                  </NavLink>
                  <NavLink to="/our-story" toggleNav={handleNavClick}>
                    Our Story
                  </NavLink>
                  {/*
                    <NavLink to="/contact-us" exact toggleNav={handleNavClick}>
                      Contact Us
                    </NavLink>
                  */}
                </ul>}
              {knowledgeCenter &&
                <ul>
                  <NavLink to="/our-story" toggleNav={handleNavClick}>
                    About WineXRay
                  </NavLink>
                  <NavLink to="/knowledge-center" toggleNav={handleNavClick}>
                    Resource Library
                  </NavLink>
                </ul>}
            </nav>
          </Grid>
        </header>
        {children}
        <Footer />
      </section>
    );
  }
}

const mapState = state => ({
  isNavOpen: state.app.get('isNavOpen')
});

const mapDispatch = dispatch => ({
  onToggleNav: value => dispatch(toggleNav(value))
});

export default connect(mapState, mapDispatch)(Layout);



// WEBPACK FOOTER //
// ./src/components/ui/Layout.js